var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contactpersons container mx-auto"},[_c('div',{staticClass:"contact-wrap"},_vm._l((_vm.accordion),function(panel,i){return _c('Panel',{key:panel.id,attrs:{"index":i,"panel":panel}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }